import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingTableOrChartSelector } from 'teacher-ui-client/components/reporting/table-or-chart-selector'
import { ReportingExportSelect, type ExportOption } from 'teacher-ui-client/components/reporting/export-select'
import { StudentSearchComponent } from 'teacher-ui-client/components/student-search'
import type Student from 'teacher-ui-client/models/student'
import { not } from 'ember-truth-helpers'
import type { TOC } from '@ember/component/template-only'

interface Signature {
  Args: {
    routePrefix: string
    isDataPresent: boolean
    exportOptions: ExportOption[]
    studentRouteName: string
    students: Student[]
  }
}

export const ReportingDashboardControls: TOC<Signature> = <template>
  <ReportingControls>
    <ReportingUiScopeSelect class="shrink basis-80" />

    <ReportingControlsGap />

    <ReportingPeriodSelect data-test-dashboard-date-range-picker />

    <ReportingControlsGap />

    <ReportingTableOrChartSelector data-test-dashboard-table-or-chart-selector @routePrefix={{@routePrefix}} />

    <ReportingExportSelect @exportOptions={{@exportOptions}} @disabled={{not @isDataPresent}} />

    <ReportingControlsGap />

    <StudentSearchComponent
      @studentRouteName={{@studentRouteName}}
      @students={{@students}}
      @includeSelectAll={{false}}
    />
  </ReportingControls>
</template>

export default ReportingDashboardControls
